import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/page.css';
import './not-found.css';

export default function NotFound() {
  return (
    <div className="page not-found">
      <div className="shell">
        <span className="eyebrow">404</span>
        <h1 className="page__title">This page isn&apos;t here.</h1>
        <p className="page__sub">
          Head back to the fire, or tell us if a link is broken.
        </p>
        <div className="not-found__actions">
          <Link className="btn btn--primary btn--lg" to="/">
            Back to camp
          </Link>
          <Link className="btn btn--secondary btn--lg" to="/feedback">
            Report a broken link
          </Link>
        </div>
      </div>
    </div>
  );
}
